import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "huddles-card customer-highlights" }
const _hoisted_2 = { class: "customer-highlights-header" }
const _hoisted_3 = { class: "highlight-item" }
const _hoisted_4 = { class: "flight-details" }
const _hoisted_5 = { class: "flight-feedback" }

import Typography from '@/components/Rain/Typography/Typography.vue'
import Carousel from 'primevue/carousel'

import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { timeSince } from '@/utils/time'
import { FontAwesomeIcon } from 'fontawesome/vue-fontawesome'
import { faCommentAltLines } from 'fontawesome/pro-regular-svg-icons'
import { OFFLINE_FEATURE_DISABLE_MESSAGE } from '@/utils/string'
import { CustomerHighlight } from '@/entities/huddles'

interface Props {
    highlights: CustomerHighlight[]
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HuddlesCustomerHighlights',
  props: {
    highlights: {}
  },
  setup(__props: any) {

const router = useRouter()
const store = useStore()

const props = __props

const hasNetworkConnection = computed(() => store.getters.hasNetworkConnection)

const navigateToFeedback = (responseId: number) => {
    if (!hasNetworkConnection.value) {
        alert(OFFLINE_FEATURE_DISABLE_MESSAGE)
        return
    }
    router.push({
        name: 'feedbackdetail',
        params: { feedbackid: responseId.toString() },
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(FontAwesomeIcon), {
        size: "lg",
        icon: _unref(faCommentAltLines)
      }, null, 8, ["icon"]),
      _createTextVNode(" Customer Highlights ")
    ]),
    _createVNode(_unref(Carousel), {
      value: _ctx.highlights,
      "num-visible": 1,
      "num-scroll": 1,
      "show-navigators": false,
      circular: "",
      pt: { indicatorList: { style: { padding: '20px 0 0 0' } } }
    }, {
      item: _withCtx((slotProps) => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(Typography, {
              variant: "caption",
              class: "flight-info"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(slotProps.data.flight_number), 1)
              ], undefined, true),
              _: 2
            }, 1024),
            _createVNode(Typography, {
              variant: "caption",
              class: "flight-info"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(slotProps.data.flight_key), 1)
              ], undefined, true),
              _: 2
            }, 1024),
            _createVNode(Typography, {
              variant: "caption",
              class: "flight-info"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(timeSince)(slotProps.data.responded)), 1)
              ], undefined, true),
              _: 2
            }, 1024)
          ]),
          _createElementVNode("span", _hoisted_5, [
            _createVNode(Typography, {
              variant: "caption",
              class: "flight-feedback-text",
              onClick: ($event: any) => (navigateToFeedback(slotProps.data.id))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(slotProps.data.comment), 1)
              ], undefined, true),
              _: 2
            }, 1032, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}
}

})